import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import store from '../store';
import Helpers from '../helpers/util';

import RadioButton from './RadioButton';
import BarIndicator from './BarIndicator';

import { setSelectedDisease } from '../actions/actionCreators';

class PrevalenceFilters extends Component {
	handleDiseaseChange = (e) => {
		const data = JSON.parse(_.get(e, 'target.dataset.object', ''));
		if (data) {
			this.setSelectedDisease(data.key);
		}
	};

	componentDidMount() {
		const { diseases } = this.props;
		if (!this.props.match.params.disease) {
			this.setDefaultDisease();
		} else {
			Helpers.pubsub.publish('barIndicator', { show: true, ...diseases[this.props.match.params.disease] });
		}
	}

	componentDidUpdate() {
		if (!this.props.match.params.disease) {
			this.setDefaultDisease();
		}
	}

	getSortedDiseases() {
		const { diseases } = this.props;
		const diseasesWithKeys = Object.keys(diseases).map((key) => ({ key, ...diseases[key] }));
		return _.sortBy(diseasesWithKeys, 'name');
	}

	setSelectedDisease(diseaseKey) {
		const { diseases } = this.props;
		Helpers.pubsub.publish('barIndicator', { show: true, ...diseases[diseaseKey] });
		store.dispatch(push(`/${window.prevalence_tab_slug}/${diseaseKey}`));
	}

	setDefaultDisease() {
		// Set the initial selected filter to the first one alphabetically
		const diseases = this.getSortedDiseases();
		const rankedDiseases = _.filter(diseases, ['is_ranked', true]);
		this.setSelectedDisease(rankedDiseases[0].key);
	}

	render() {
		// Filter diseases into 2 groups
		const diseases = this.getSortedDiseases();
		var divStyle = {
			height: `${Math.ceil(diseases.length / 2) * 55}px`,
		};

		return (
			<div className="sidebar-section prevalence-filters">
				<div className="prevalence-filters__inner">
					<div className="prevalence-filters__title">Select a disease to reveal the risk level</div>
					{/* indicator */}
					<Switch location={this.props.location}>
						<Route path={`/${window.prevalence_tab_slug}/:disease?`} component={BarIndicator} />
					</Switch>
					{/* end indicator */}
					<div className="prevalence-filters__radio-group" style={divStyle}>
						{diseases.map((disease) => (
							<RadioButton
								key={disease.key}
								id={`${disease.key}:${disease.is_ranked}`}
								label={disease.name}
								name="disease"
								data={disease}
								checked={disease.key === this.props.match.params.disease}
								onChange={this.handleDiseaseChange}
							/>
						))}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const { countries, diseases } = state.json.data.prevalence;
	return {
		countries,
		diseases,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setSelectedDisease: (disease) => dispatch(setSelectedDisease(disease)),
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrevalenceFilters));
